<template>
  <vue-good-table
    v-bind="$attrs"
    :rows="rows"
    :columns="columns"
    ref="checkbox-table"
    styleClass="vgt-table"
    :search-options="{
      enabled: true,
      externalQuery: searchValue,
    }"
    :pagination-options="{ enabled: enablePagination(), perPage: rowsPerPage }"
    @on-row-click="handleCheck"
  >
    <div slot="emptystate" class="empty-transfer">
      <div class="empty-transfer__container">
        <empty-icon class="empty-transfer__icon" />
      </div>
      <span class="empty-transfer__text">{{ emptyText }}</span>
    </div>
    <div slot="table-actions" class="table-actions" v-if="title || search">
      <span v-if="title" :title="title" class="table__title">{{ title }}</span>
      <div class="table-actions__items" v-if="search">
        <hcc-input
          :placeholder="searchText"
          v-model="searchValue"
          v-if="search"
          @keyup.enter="$emit('search', searchValue)"
        >
          <template #icon>
            <search-icon />
          </template>
        </hcc-input>
      </div>
    </div>
    <template slot="table-row" slot-scope="props">
      <span v-if="props.column.field == 'select'" class="select-box">
        <hcc-checkbox
          @change="handleCheck({ row: props.row })"
          :name="props.row.id"
          :value="isCheckedRow(props.row)"
        />
      </span>
      <span v-if="props.column.field == 'status'">
        <div
          v-if="props.row.status === 'online' || props.row.status === 'Online'"
        >
          <hcc-status-dot active class="status-dot" />{{ props.row.status }}
        </div>
        <div v-else>
          <hcc-status-dot :color="props.row.status" class="status-dot" />{{
            props.row.status
          }}
        </div>
      </span>
      <span v-else-if="props.column.field == 'campaigns'">
        <div
          v-if="props.row.campaigns.length !== 0"
          @click.stop="doNothing"
          class="select-div"
        >
          <hcc-select
            option-label="name"
            track-by="id"
            :options="props.row.campaigns"
            :placeholder="campaignsTitle"
            @select="selectedCampaign($event, props.row)"
            @open="openSelect($event, props.row)"
            :value="getSelectedCampaign(props.row)"
            open-direction="bottom"
            customClass="select"
          />
        </div>
      </span>
      <span v-else>
        {{ props.formattedRow[props.column.field] }}
      </span>
    </template>
    <template slot="pagination-bottom" slot-scope="props">
      <hcc-pagination
        :total="props.total"
        :rowsPerPage="rowsPerPage"
        :actualPage="actualPage"
        :pageChanged="props.pageChanged"
        @page-change="actualPage = $event"
      />
    </template>
  </vue-good-table>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import SearchIcon from '@/assets/icons/search.svg';
import EmptyIcon from '@/assets/images/paper.svg';
import HccPagination from './HccPagination.vue';
import HccInput from '../HccInput/index.vue';
import HccStatusDot from '../HccStatusDot/index.vue';
import HccSelect from '../HccSelect/index.vue';
import HccCheckbox from '../HccCheckbox/index.vue';

export default {
  components: {
    VueGoodTable,
    HccPagination,
    HccInput,
    HccStatusDot,
    HccSelect,
    HccCheckbox,
    SearchIcon,
    EmptyIcon,
  },
  props: {
    title: {
      type: String,
    },
    initialPage: {
      type: Number,
      default: 1,
    },
    columns: {
      type: Array,
    },
    pagination: {
      type: Boolean,
      default: true,
    },
    rows: {
      type: Array,
      default: () => [],
    },
    search: {
      type: Boolean,
      default: false,
    },
    selectOptions: {
      type: Boolean,
      default: false,
    },
    campaignId: {
      type: String,
      required: true,
    },
    rowsPerPage: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      searchValue: '',
      searchText: this.$t('shared-components.table.search'),
      actualPage: this.initialPage,
      campaignsTitle: this.$t('campaigns.title'),
      checkedRows: {
        originalIndex: '',
      },
      actualSelectedCampaigns: [],
    };
  },
  computed: {
    emptyText() {
      return this.$t('shared-components.table.empty');
    },
    emptyRows() {
      return this.rows.length === 0;
    },
    onePage() {
      return this.rows.length <= this.rowsPerPage;
    },
  },
  methods: {
    enablePagination() {
      return (this.emptyRows || this.onePage) ? false : !!this.$props.pagination;
    },

    selectedCampaign(campaign, row) {
      this.clearSelectedCampaign(row.originalIndex);
      this.$emit('selectedCampaign', { row, campaign });
      this.actualSelectedCampaigns.push({
        rowID: row.originalIndex,
        name: campaign.name,
        id: campaign.id,
      });
    },
    openSelect(event, row) {
      this.showScrollMessage = row.campaigns.length > 5;
      this.lastRowOpened = row.originalIndex % 3 === 0 && row.originalIndex !== 0;

      this.$emit('openSelect', { event, row });
    },
    getSelectedCampaign(row) {
      return this.actualSelectedCampaigns.find((option) => option.rowID === row.originalIndex)
        || row.campaigns.find(({ id }) => id === this.campaignId);
    },
    clearSelectedCampaign(index) {
      const i = this.actualSelectedCampaigns.findIndex((option) => option.rowID === index);
      if (i !== -1) {
        this.actualSelectedCampaigns.splice(i, 1);
      }
    },
    isCheckedRow(row) {
      return this.checkedRows.originalIndex === row.originalIndex;
    },
    handleCheck({ row }) {
      const checkedRow = this.checkedRows.originalIndex === row.originalIndex;
      const campaign = row.campaigns.length === 1
        ? row.campaigns[0]
        : this.getSelectedCampaign(row);

      if (checkedRow) {
        this.checkedRows = {
          originalIndex: '',
        };
      } else {
        this.checkedRows = row;
      }
      this.$emit('checkedRow', { row, campaign: campaign || {} });
    },
    doNothing() {
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~styles/components/transfer-conversation-table.scss";
</style>
